import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState, useEffect, useRef } from 'preact/hooks'
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)
    const facetRef = useRef(null)
    

    useEffect(() => {
        function handleClickOutside(event) {
            if (event.target.getAttribute('for') === 'toggle-mobile-sidebar') {
                return
            }

            if (facetRef.current && !facetRef.current.contains(event.target)) {
                if (active) {
                    setTimeout(() => {
                        setActive(false)
                    }, 50)
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [active])

    const toggleActiveUpdated = () => {
        const activeFacets = document.querySelectorAll('.ns-sidebar-dropdown.ns-active')
        activeFacets.forEach((facetElement) => {
            if (facetElement !== facetRef.current) {
                facetElement.classList.remove('ns-active')
            }
        })
        setActive(!active)
    }

    return (
        <li ref={facetRef} class={`ns-sidebar-dropdown ns-rangeFacet ${active ? "ns-active" : ""}`}>
            <a
                class="ns-sidebar-facet-title ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                onClick={toggleActiveUpdated}>
                {facet.name}
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                            currency="kr"
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                            currency="kr"
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}
